import React from 'react';
import PropTypes from 'prop-types';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Button, Form, Row, Col } from 'react-bootstrap'




const getCaret = direction => {
    if (direction === 'asc') {
        return (
            <span> <i className="fa fa-sort-asc" aria-hidden="true" /></span>
        );
    }

    if (direction === 'desc') {
        return (
            <span> <i className="fa fa-sort-desc" aria-hidden="true" /></span>
        );
    }

    return (
        <span> <i className="fa fa-sort" aria-hidden="true" /></span>
    );
};

class TablePessoa extends React.Component {

    situacaoFormatter = (cell, row) => {
        return `${row.is_ativo ? 'Ativo' : 'Excluído'}`;
    };



    actionsFormatter = (cell, row, obj) => {
        let acoes = <div>
            <Button title="Editar" size="sm" variant="warning" href={`${this.props.edit_url}/${row.id}`}> <span className="fa fa-pencil" /> </Button>
            <Button style={{ marginLeft: 10 }} title={this.props.checked ? "Ativar" : "Excluir"} size="sm" variant={this.props.checked ? "success" : "danger"}
                onClick={this.props.handleClickDelete ? () => { this.props.handleClickDelete(row.id, row.nome); } : null}  >
                <span className={this.props.checked ? "fa fa-check" : "fa fa-trash"} /> </Button>
            &nbsp;
                    </div>
        return acoes;
    };


    columns = [{
        dataField: 'nome_completo',
        text: 'Nome',
        sort: true,
        filter: textFilter({
            placeholder: 'Consultar',  // custom the input placeholder
        }),
        style: {
            width: '25%'
        }
    },
    {
        dataField: 'telefone',
        text: 'Telefone',
        sort: true,
        filter: textFilter({
            placeholder: 'Consultar',  // custom the input placeholder
        }),
        style: {
            width: '15%'
        }
    },

    {
        dataField: 'logradouro',
        text: 'Logradouro',
        sort: true,
        filter: textFilter({
            placeholder: 'Consultar',  // custom the input placeholder
        })
    },
    {
        dataField: 'cidade',
        text: 'Cidade',
        sort: true,
        filter: textFilter({
            placeholder: 'Consultar',  // custom the input placeholder
        })
    },
    {
        dataField: 'ativo',
        text: 'Situação',
        formatter: this.situacaoFormatter
    },
    {
        text: 'Opções',
        formatter: this.actionsFormatter,
        style: {
            width: '15%'
        }
    }
    ];
    constructor(props) {
        super(props);

        this.options = {
            sortIndicator: true,
            noDataText: 'Sem dados'
        };

        this.selectRowProp = {
            mode: 'radio',
            bgColor: '#c1f291',
            onSelect: props.handleRowSelect,
            clickToSelect: true,
            hideSelectColumn: true
        };
    }

    render() {
        return (<>
            <Row>
                <Col className="text-right">
                    <Form.Check
                        checked={this.props.checked}
                        onChange={this.props.handleClickTodos}
                        type="switch"
                        id="custom-switch"
                        label="Excluídos"
                    />
                </Col>

            </Row>

            <BootstrapTable pagination={paginationFactory()} striped hover condensed keyField='id'
                data={this.props.pessoaObject.results ? this.props.pessoaObject.results : []} columns={this.columns} filter={filterFactory()} >

                {/* <BootstrapTable  version="4" data={this.props.pessoaObject.results} options={this.options} bordered={false} striped hover condensed>
                <TableHeaderColumn dataField="id" isKey hidden>Id</TableHeaderColumn>

                <TableHeaderColumn
                    dataField="nome"
                    dataSort={true}
                    caretRender={getCaret}
                    //filter={{type: 'TextFilter', delay: 0 }}
                    columnTitle
                    dataFormat={nomeFormatter}
                >
                    Nome
                </TableHeaderColumn>

                <TableHeaderColumn
                    dataField="telefone"
                    dataSort={true}
                    caretRender={getCaret}
                    //filter={{type: 'TextFilter', delay: 0 }}
                    columnTitle
                >
                    Telefone
                </TableHeaderColumn>

                <TableHeaderColumn
                    dataField="email"
                    dataSort={true}
                    caretRender={getCaret}
                    //filter={{type: 'TextFilter', delay: 0 }}
                    columnTitle
                >
                    Email
                </TableHeaderColumn>

                <TableHeaderColumn
                    dataFormat={actionsFormatter}
                    formatExtraData={this.props}
                    //filter={{type: 'TextFilter', delay: 0 }}
                    columnTitle
                >
                    Ações
                </TableHeaderColumn> */}
            </BootstrapTable>
        </>);
    }

}

TablePessoa.propTypes = {
    pessoaObject: PropTypes.array.isRequired,
    handleClickEditar: PropTypes.func.isRequired,
    handleClickTodos: PropTypes.func.isRequired,
    handleClickDelete: PropTypes.func.isRequired,
    handleRowSelect: PropTypes.func.isRequired,
    checked: PropTypes.bool
};

export default TablePessoa;
